import { z } from 'zod';

export const MetaTag = z.object({
	type: z.enum(['name', 'property']),
	key: z.string(),
	content: z.string(),
});
export type MetaTag = z.infer<typeof MetaTag>;
